export const DEFAULT_VA_CONFIDENCE_THRESHOLD = 0.5;
export const POST_SESSION_FLOW_FEATURE = 'PostSessionFlowGroup.EnablePostSessionFlow';
export const ADVANCED_CONVERSATION_ROUTING_FEATURE =
  'AdvancedConversationRoutingGroup.EnableAdvancedConversationRouting';
export const AI_INSIGHTS_FEATURE = 'AIGroup.AiInsights';

export const PROJECT_FLOWS = 'Project Flows';
export const SUBFLOWS = 'Subflows';
